// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/arrow/v1/arrow.proto (package chalk.arrow.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/arrow/v1/arrow.proto.
 */
export const file_chalk_arrow_v1_arrow: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message chalk.arrow.v1.Schema
 */
export type Schema = Message<"chalk.arrow.v1.Schema"> & {
  /**
   * @generated from field: repeated chalk.arrow.v1.Field columns = 1;
   */
  columns: Field[];

  /**
   * @generated from field: map<string, string> metadata = 2;
   */
  metadata: { [key: string]: string };
};

/**
 * Describes the message chalk.arrow.v1.Schema.
 * Use `create(SchemaSchema)` to create a new message.
 */
export const SchemaSchema: GenMessage<Schema> = /*@__PURE__*/
  messageDesc(file_chalk_arrow_v1_arrow, 0);

/**
 * @generated from message chalk.arrow.v1.Field
 */
export type Field = Message<"chalk.arrow.v1.Field"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: chalk.arrow.v1.ArrowType arrow_type = 2;
   */
  arrowType?: ArrowType;

  /**
   * @generated from field: bool nullable = 3;
   */
  nullable: boolean;

  /**
   * @generated from field: repeated chalk.arrow.v1.Field children = 4;
   */
  children: Field[];

  /**
   * @generated from field: map<string, string> metadata = 5;
   */
  metadata: { [key: string]: string };
};

/**
 * Describes the message chalk.arrow.v1.Field.
 * Use `create(FieldSchema)` to create a new message.
 */
export const FieldSchema: GenMessage<Field> = /*@__PURE__*/
  messageDesc(file_chalk_arrow_v1_arrow, 1);

/**
 * @generated from message chalk.arrow.v1.FixedSizeBinary
 */
export type FixedSizeBinary = Message<"chalk.arrow.v1.FixedSizeBinary"> & {
  /**
   * @generated from field: int32 length = 1;
   */
  length: number;
};

/**
 * Describes the message chalk.arrow.v1.FixedSizeBinary.
 * Use `create(FixedSizeBinarySchema)` to create a new message.
 */
export const FixedSizeBinarySchema: GenMessage<FixedSizeBinary> = /*@__PURE__*/
  messageDesc(file_chalk_arrow_v1_arrow, 2);

/**
 * @generated from message chalk.arrow.v1.Timestamp
 */
export type Timestamp = Message<"chalk.arrow.v1.Timestamp"> & {
  /**
   * @generated from field: chalk.arrow.v1.TimeUnit time_unit = 1;
   */
  timeUnit: TimeUnit;

  /**
   * @generated from field: string timezone = 2;
   */
  timezone: string;
};

/**
 * Describes the message chalk.arrow.v1.Timestamp.
 * Use `create(TimestampSchema)` to create a new message.
 */
export const TimestampSchema: GenMessage<Timestamp> = /*@__PURE__*/
  messageDesc(file_chalk_arrow_v1_arrow, 3);

/**
 * @generated from message chalk.arrow.v1.Decimal
 */
export type Decimal = Message<"chalk.arrow.v1.Decimal"> & {
  /**
   * @generated from field: int32 precision = 1;
   */
  precision: number;

  /**
   * @generated from field: int32 scale = 2;
   */
  scale: number;
};

/**
 * Describes the message chalk.arrow.v1.Decimal.
 * Use `create(DecimalSchema)` to create a new message.
 */
export const DecimalSchema: GenMessage<Decimal> = /*@__PURE__*/
  messageDesc(file_chalk_arrow_v1_arrow, 4);

/**
 * @generated from message chalk.arrow.v1.List
 */
export type List = Message<"chalk.arrow.v1.List"> & {
  /**
   * @generated from field: chalk.arrow.v1.Field field_type = 1;
   */
  fieldType?: Field;
};

/**
 * Describes the message chalk.arrow.v1.List.
 * Use `create(ListSchema)` to create a new message.
 */
export const ListSchema: GenMessage<List> = /*@__PURE__*/
  messageDesc(file_chalk_arrow_v1_arrow, 5);

/**
 * @generated from message chalk.arrow.v1.FixedSizeList
 */
export type FixedSizeList = Message<"chalk.arrow.v1.FixedSizeList"> & {
  /**
   * @generated from field: chalk.arrow.v1.Field field_type = 1;
   */
  fieldType?: Field;

  /**
   * @generated from field: int32 list_size = 2;
   */
  listSize: number;
};

/**
 * Describes the message chalk.arrow.v1.FixedSizeList.
 * Use `create(FixedSizeListSchema)` to create a new message.
 */
export const FixedSizeListSchema: GenMessage<FixedSizeList> = /*@__PURE__*/
  messageDesc(file_chalk_arrow_v1_arrow, 6);

/**
 * @generated from message chalk.arrow.v1.Struct
 */
export type Struct = Message<"chalk.arrow.v1.Struct"> & {
  /**
   * @generated from field: repeated chalk.arrow.v1.Field sub_field_types = 1;
   */
  subFieldTypes: Field[];
};

/**
 * Describes the message chalk.arrow.v1.Struct.
 * Use `create(StructSchema)` to create a new message.
 */
export const StructSchema: GenMessage<Struct> = /*@__PURE__*/
  messageDesc(file_chalk_arrow_v1_arrow, 7);

/**
 * @generated from message chalk.arrow.v1.Map
 */
export type Map = Message<"chalk.arrow.v1.Map"> & {
  /**
   * @generated from field: chalk.arrow.v1.Field key_field = 1;
   */
  keyField?: Field;

  /**
   * @generated from field: chalk.arrow.v1.Field item_field = 2;
   */
  itemField?: Field;

  /**
   * @generated from field: bool keys_sorted = 3;
   */
  keysSorted: boolean;
};

/**
 * Describes the message chalk.arrow.v1.Map.
 * Use `create(MapSchema)` to create a new message.
 */
export const MapSchema: GenMessage<Map> = /*@__PURE__*/
  messageDesc(file_chalk_arrow_v1_arrow, 8);

/**
 * @generated from message chalk.arrow.v1.ScalarListValue
 */
export type ScalarListValue = Message<"chalk.arrow.v1.ScalarListValue"> & {
  /**
   * @generated from field: bytes arrow_data = 1;
   */
  arrowData: Uint8Array;

  /**
   * @generated from field: chalk.arrow.v1.Schema schema = 2;
   */
  schema?: Schema;
};

/**
 * Describes the message chalk.arrow.v1.ScalarListValue.
 * Use `create(ScalarListValueSchema)` to create a new message.
 */
export const ScalarListValueSchema: GenMessage<ScalarListValue> = /*@__PURE__*/
  messageDesc(file_chalk_arrow_v1_arrow, 9);

/**
 * @generated from message chalk.arrow.v1.ScalarTime32Value
 */
export type ScalarTime32Value = Message<"chalk.arrow.v1.ScalarTime32Value"> & {
  /**
   * @generated from oneof chalk.arrow.v1.ScalarTime32Value.value
   */
  value: {
    /**
     * @generated from field: int32 time32_second_value = 1;
     */
    value: number;
    case: "time32SecondValue";
  } | {
    /**
     * @generated from field: int32 time32_millisecond_value = 2;
     */
    value: number;
    case: "time32MillisecondValue";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message chalk.arrow.v1.ScalarTime32Value.
 * Use `create(ScalarTime32ValueSchema)` to create a new message.
 */
export const ScalarTime32ValueSchema: GenMessage<ScalarTime32Value> = /*@__PURE__*/
  messageDesc(file_chalk_arrow_v1_arrow, 10);

/**
 * @generated from message chalk.arrow.v1.ScalarTime64Value
 */
export type ScalarTime64Value = Message<"chalk.arrow.v1.ScalarTime64Value"> & {
  /**
   * @generated from oneof chalk.arrow.v1.ScalarTime64Value.value
   */
  value: {
    /**
     * @generated from field: int64 time64_microsecond_value = 1;
     */
    value: bigint;
    case: "time64MicrosecondValue";
  } | {
    /**
     * @generated from field: int64 time64_nanosecond_value = 2;
     */
    value: bigint;
    case: "time64NanosecondValue";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message chalk.arrow.v1.ScalarTime64Value.
 * Use `create(ScalarTime64ValueSchema)` to create a new message.
 */
export const ScalarTime64ValueSchema: GenMessage<ScalarTime64Value> = /*@__PURE__*/
  messageDesc(file_chalk_arrow_v1_arrow, 11);

/**
 * @generated from message chalk.arrow.v1.ScalarTimestampValue
 */
export type ScalarTimestampValue = Message<"chalk.arrow.v1.ScalarTimestampValue"> & {
  /**
   * @generated from oneof chalk.arrow.v1.ScalarTimestampValue.value
   */
  value: {
    /**
     * @generated from field: int64 time_microsecond_value = 1;
     */
    value: bigint;
    case: "timeMicrosecondValue";
  } | {
    /**
     * @generated from field: int64 time_nanosecond_value = 2;
     */
    value: bigint;
    case: "timeNanosecondValue";
  } | {
    /**
     * @generated from field: int64 time_second_value = 3;
     */
    value: bigint;
    case: "timeSecondValue";
  } | {
    /**
     * @generated from field: int64 time_millisecond_value = 4;
     */
    value: bigint;
    case: "timeMillisecondValue";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: string timezone = 5;
   */
  timezone: string;
};

/**
 * Describes the message chalk.arrow.v1.ScalarTimestampValue.
 * Use `create(ScalarTimestampValueSchema)` to create a new message.
 */
export const ScalarTimestampValueSchema: GenMessage<ScalarTimestampValue> = /*@__PURE__*/
  messageDesc(file_chalk_arrow_v1_arrow, 12);

/**
 * @generated from message chalk.arrow.v1.StructValue
 */
export type StructValue = Message<"chalk.arrow.v1.StructValue"> & {
  /**
   * @generated from field: repeated chalk.arrow.v1.ScalarValue field_values = 2;
   */
  fieldValues: ScalarValue[];

  /**
   * @generated from field: repeated chalk.arrow.v1.Field fields = 3;
   */
  fields: Field[];
};

/**
 * Describes the message chalk.arrow.v1.StructValue.
 * Use `create(StructValueSchema)` to create a new message.
 */
export const StructValueSchema: GenMessage<StructValue> = /*@__PURE__*/
  messageDesc(file_chalk_arrow_v1_arrow, 13);

/**
 * @generated from message chalk.arrow.v1.ScalarFixedSizeBinary
 */
export type ScalarFixedSizeBinary = Message<"chalk.arrow.v1.ScalarFixedSizeBinary"> & {
  /**
   * @generated from field: bytes values = 1;
   */
  values: Uint8Array;

  /**
   * @generated from field: int32 length = 2;
   */
  length: number;
};

/**
 * Describes the message chalk.arrow.v1.ScalarFixedSizeBinary.
 * Use `create(ScalarFixedSizeBinarySchema)` to create a new message.
 */
export const ScalarFixedSizeBinarySchema: GenMessage<ScalarFixedSizeBinary> = /*@__PURE__*/
  messageDesc(file_chalk_arrow_v1_arrow, 14);

/**
 * @generated from message chalk.arrow.v1.DecimalValue
 */
export type DecimalValue = Message<"chalk.arrow.v1.DecimalValue"> & {
  /**
   * @generated from field: bytes value = 1;
   */
  value: Uint8Array;

  /**
   * @generated from field: int32 precision = 2;
   */
  precision: number;

  /**
   * @generated from field: int32 scale = 3;
   */
  scale: number;
};

/**
 * Describes the message chalk.arrow.v1.DecimalValue.
 * Use `create(DecimalValueSchema)` to create a new message.
 */
export const DecimalValueSchema: GenMessage<DecimalValue> = /*@__PURE__*/
  messageDesc(file_chalk_arrow_v1_arrow, 15);

/**
 * Extension is used to
 *
 * @generated from message chalk.arrow.v1.Extension
 */
export type Extension = Message<"chalk.arrow.v1.Extension"> & {
  /**
   * The name of the extension -- e.g. arrow.json. See
   * https://arrow.apache.org/docs/format/CanonicalExtensions.html
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * The underlying storage type for this extension type.
   *
   * @generated from field: chalk.arrow.v1.ArrowType storage_type = 2;
   */
  storageType?: ArrowType;
};

/**
 * Describes the message chalk.arrow.v1.Extension.
 * Use `create(ExtensionSchema)` to create a new message.
 */
export const ExtensionSchema: GenMessage<Extension> = /*@__PURE__*/
  messageDesc(file_chalk_arrow_v1_arrow, 16);

/**
 * @generated from message chalk.arrow.v1.ExtensionValue
 */
export type ExtensionValue = Message<"chalk.arrow.v1.ExtensionValue"> & {
  /**
   * @generated from field: chalk.arrow.v1.Extension extension_type = 1;
   */
  extensionType?: Extension;

  /**
   * @generated from field: chalk.arrow.v1.ScalarValue storage_value = 2;
   */
  storageValue?: ScalarValue;
};

/**
 * Describes the message chalk.arrow.v1.ExtensionValue.
 * Use `create(ExtensionValueSchema)` to create a new message.
 */
export const ExtensionValueSchema: GenMessage<ExtensionValue> = /*@__PURE__*/
  messageDesc(file_chalk_arrow_v1_arrow, 17);

/**
 * @generated from message chalk.arrow.v1.ScalarValue
 */
export type ScalarValue = Message<"chalk.arrow.v1.ScalarValue"> & {
  /**
   * @generated from oneof chalk.arrow.v1.ScalarValue.value
   */
  value: {
    /**
     * Group popular types at the top
     * to save space in the serialized
     * message.
     *
     * @generated from field: chalk.arrow.v1.ArrowType null_value = 1;
     */
    value: ArrowType;
    case: "nullValue";
  } | {
    /**
     * @generated from field: bool bool_value = 2;
     */
    value: boolean;
    case: "boolValue";
  } | {
    /**
     * @generated from field: double float64_value = 3;
     */
    value: number;
    case: "float64Value";
  } | {
    /**
     * @generated from field: int64 int64_value = 4;
     */
    value: bigint;
    case: "int64Value";
  } | {
    /**
     * @generated from field: string large_utf8_value = 5;
     */
    value: string;
    case: "largeUtf8Value";
  } | {
    /**
     * @generated from field: chalk.arrow.v1.ScalarTimestampValue timestamp_value = 6;
     */
    value: ScalarTimestampValue;
    case: "timestampValue";
  } | {
    /**
     * @generated from field: int64 date_64_value = 7;
     */
    value: bigint;
    case: "date64Value";
  } | {
    /**
     * @generated from field: chalk.arrow.v1.StructValue struct_value = 8;
     */
    value: StructValue;
    case: "structValue";
  } | {
    /**
     * @generated from field: chalk.arrow.v1.ScalarListValue large_list_value = 9;
     */
    value: ScalarListValue;
    case: "largeListValue";
  } | {
    /**
     * Leave placeholders for 11-15 in case
     * we get the most popular types wrong.
     *
     * @generated from field: chalk.arrow.v1.ScalarTime64Value time64_value = 10;
     */
    value: ScalarTime64Value;
    case: "time64Value";
  } | {
    /**
     * @generated from field: int64 duration_second_value = 16;
     */
    value: bigint;
    case: "durationSecondValue";
  } | {
    /**
     * @generated from field: int64 duration_millisecond_value = 17;
     */
    value: bigint;
    case: "durationMillisecondValue";
  } | {
    /**
     * @generated from field: int64 duration_microsecond_value = 18;
     */
    value: bigint;
    case: "durationMicrosecondValue";
  } | {
    /**
     * @generated from field: int64 duration_nanosecond_value = 19;
     */
    value: bigint;
    case: "durationNanosecondValue";
  } | {
    /**
     * @generated from field: string utf8_value = 20;
     */
    value: string;
    case: "utf8Value";
  } | {
    /**
     * @generated from field: int32 int8_value = 21;
     */
    value: number;
    case: "int8Value";
  } | {
    /**
     * @generated from field: int32 int16_value = 22;
     */
    value: number;
    case: "int16Value";
  } | {
    /**
     * @generated from field: int32 int32_value = 23;
     */
    value: number;
    case: "int32Value";
  } | {
    /**
     * @generated from field: uint32 uint8_value = 24;
     */
    value: number;
    case: "uint8Value";
  } | {
    /**
     * @generated from field: uint32 uint16_value = 25;
     */
    value: number;
    case: "uint16Value";
  } | {
    /**
     * @generated from field: uint32 uint32_value = 26;
     */
    value: number;
    case: "uint32Value";
  } | {
    /**
     * @generated from field: uint64 uint64_value = 27;
     */
    value: bigint;
    case: "uint64Value";
  } | {
    /**
     * @generated from field: float float16_value = 28;
     */
    value: number;
    case: "float16Value";
  } | {
    /**
     * @generated from field: float float32_value = 29;
     */
    value: number;
    case: "float32Value";
  } | {
    /**
     * @generated from field: int32 date_32_value = 30;
     */
    value: number;
    case: "date32Value";
  } | {
    /**
     * @generated from field: chalk.arrow.v1.ScalarTime32Value time32_value = 31;
     */
    value: ScalarTime32Value;
    case: "time32Value";
  } | {
    /**
     * @generated from field: chalk.arrow.v1.ScalarListValue list_value = 32;
     */
    value: ScalarListValue;
    case: "listValue";
  } | {
    /**
     * @generated from field: chalk.arrow.v1.ScalarListValue fixed_size_list_value = 33;
     */
    value: ScalarListValue;
    case: "fixedSizeListValue";
  } | {
    /**
     * @generated from field: chalk.arrow.v1.ScalarListValue map_value = 34;
     */
    value: ScalarListValue;
    case: "mapValue";
  } | {
    /**
     * @generated from field: bytes binary_value = 35;
     */
    value: Uint8Array;
    case: "binaryValue";
  } | {
    /**
     * @generated from field: bytes large_binary_value = 36;
     */
    value: Uint8Array;
    case: "largeBinaryValue";
  } | {
    /**
     * @generated from field: chalk.arrow.v1.ScalarFixedSizeBinary fixed_size_binary_value = 37;
     */
    value: ScalarFixedSizeBinary;
    case: "fixedSizeBinaryValue";
  } | {
    /**
     * @generated from field: chalk.arrow.v1.DecimalValue decimal128_value = 38;
     */
    value: DecimalValue;
    case: "decimal128Value";
  } | {
    /**
     * @generated from field: chalk.arrow.v1.DecimalValue decimal256_value = 39;
     */
    value: DecimalValue;
    case: "decimal256Value";
  } | {
    /**
     * @generated from field: chalk.arrow.v1.ExtensionValue extension_value = 40;
     */
    value: ExtensionValue;
    case: "extensionValue";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message chalk.arrow.v1.ScalarValue.
 * Use `create(ScalarValueSchema)` to create a new message.
 */
export const ScalarValueSchema: GenMessage<ScalarValue> = /*@__PURE__*/
  messageDesc(file_chalk_arrow_v1_arrow, 18);

/**
 * @generated from message chalk.arrow.v1.ArrowType
 */
export type ArrowType = Message<"chalk.arrow.v1.ArrowType"> & {
  /**
   * @generated from oneof chalk.arrow.v1.ArrowType.arrow_type_enum
   */
  arrowTypeEnum: {
    /**
     * Group popular types at the top
     * to save space in the serialized
     * message.
     *
     * @generated from field: chalk.arrow.v1.EmptyMessage none = 1;
     */
    value: EmptyMessage;
    case: "none";
  } | {
    /**
     * @generated from field: chalk.arrow.v1.EmptyMessage bool = 2;
     */
    value: EmptyMessage;
    case: "bool";
  } | {
    /**
     * @generated from field: chalk.arrow.v1.EmptyMessage float64 = 3;
     */
    value: EmptyMessage;
    case: "float64";
  } | {
    /**
     * @generated from field: chalk.arrow.v1.EmptyMessage int64 = 4;
     */
    value: EmptyMessage;
    case: "int64";
  } | {
    /**
     * @generated from field: chalk.arrow.v1.EmptyMessage large_utf8 = 5;
     */
    value: EmptyMessage;
    case: "largeUtf8";
  } | {
    /**
     * @generated from field: chalk.arrow.v1.Timestamp timestamp = 6;
     */
    value: Timestamp;
    case: "timestamp";
  } | {
    /**
     * @generated from field: chalk.arrow.v1.EmptyMessage date64 = 7;
     */
    value: EmptyMessage;
    case: "date64";
  } | {
    /**
     * @generated from field: chalk.arrow.v1.Struct struct = 8;
     */
    value: Struct;
    case: "struct";
  } | {
    /**
     * @generated from field: chalk.arrow.v1.List large_list = 9;
     */
    value: List;
    case: "largeList";
  } | {
    /**
     * Leave placeholders for 11-15 in case
     * we get the most popular types wrong.
     *
     * @generated from field: chalk.arrow.v1.TimeUnit time64 = 10;
     */
    value: TimeUnit;
    case: "time64";
  } | {
    /**
     * @generated from field: chalk.arrow.v1.TimeUnit duration = 16;
     */
    value: TimeUnit;
    case: "duration";
  } | {
    /**
     * @generated from field: chalk.arrow.v1.EmptyMessage utf8 = 17;
     */
    value: EmptyMessage;
    case: "utf8";
  } | {
    /**
     * @generated from field: chalk.arrow.v1.EmptyMessage int8 = 18;
     */
    value: EmptyMessage;
    case: "int8";
  } | {
    /**
     * @generated from field: chalk.arrow.v1.EmptyMessage int16 = 19;
     */
    value: EmptyMessage;
    case: "int16";
  } | {
    /**
     * @generated from field: chalk.arrow.v1.EmptyMessage int32 = 20;
     */
    value: EmptyMessage;
    case: "int32";
  } | {
    /**
     * @generated from field: chalk.arrow.v1.EmptyMessage uint8 = 21;
     */
    value: EmptyMessage;
    case: "uint8";
  } | {
    /**
     * @generated from field: chalk.arrow.v1.EmptyMessage uint16 = 22;
     */
    value: EmptyMessage;
    case: "uint16";
  } | {
    /**
     * @generated from field: chalk.arrow.v1.EmptyMessage uint32 = 23;
     */
    value: EmptyMessage;
    case: "uint32";
  } | {
    /**
     * @generated from field: chalk.arrow.v1.EmptyMessage uint64 = 24;
     */
    value: EmptyMessage;
    case: "uint64";
  } | {
    /**
     * @generated from field: chalk.arrow.v1.EmptyMessage float16 = 25;
     */
    value: EmptyMessage;
    case: "float16";
  } | {
    /**
     * @generated from field: chalk.arrow.v1.EmptyMessage float32 = 26;
     */
    value: EmptyMessage;
    case: "float32";
  } | {
    /**
     * @generated from field: chalk.arrow.v1.EmptyMessage date32 = 27;
     */
    value: EmptyMessage;
    case: "date32";
  } | {
    /**
     * @generated from field: chalk.arrow.v1.TimeUnit time32 = 28;
     */
    value: TimeUnit;
    case: "time32";
  } | {
    /**
     * @generated from field: chalk.arrow.v1.List list = 29;
     */
    value: List;
    case: "list";
  } | {
    /**
     * @generated from field: chalk.arrow.v1.FixedSizeList fixed_size_list = 30;
     */
    value: FixedSizeList;
    case: "fixedSizeList";
  } | {
    /**
     * @generated from field: chalk.arrow.v1.EmptyMessage binary = 31;
     */
    value: EmptyMessage;
    case: "binary";
  } | {
    /**
     * @generated from field: chalk.arrow.v1.EmptyMessage large_binary = 32;
     */
    value: EmptyMessage;
    case: "largeBinary";
  } | {
    /**
     * @generated from field: int32 fixed_size_binary = 33;
     */
    value: number;
    case: "fixedSizeBinary";
  } | {
    /**
     * @generated from field: chalk.arrow.v1.Decimal decimal_128 = 34;
     */
    value: Decimal;
    case: "decimal128";
  } | {
    /**
     * @generated from field: chalk.arrow.v1.Decimal decimal_256 = 35;
     */
    value: Decimal;
    case: "decimal256";
  } | {
    /**
     * @generated from field: chalk.arrow.v1.Map map = 36;
     */
    value: Map;
    case: "map";
  } | {
    /**
     * @generated from field: chalk.arrow.v1.Extension extension = 37;
     */
    value: Extension;
    case: "extension";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message chalk.arrow.v1.ArrowType.
 * Use `create(ArrowTypeSchema)` to create a new message.
 */
export const ArrowTypeSchema: GenMessage<ArrowType> = /*@__PURE__*/
  messageDesc(file_chalk_arrow_v1_arrow, 19);

/**
 * @generated from message chalk.arrow.v1.EmptyMessage
 */
export type EmptyMessage = Message<"chalk.arrow.v1.EmptyMessage"> & {
};

/**
 * Describes the message chalk.arrow.v1.EmptyMessage.
 * Use `create(EmptyMessageSchema)` to create a new message.
 */
export const EmptyMessageSchema: GenMessage<EmptyMessage> = /*@__PURE__*/
  messageDesc(file_chalk_arrow_v1_arrow, 20);

/**
 * / A Table, encoded as parquet bytes.
 *
 * @generated from message chalk.arrow.v1.TableParquetBytes
 */
export type TableParquetBytes = Message<"chalk.arrow.v1.TableParquetBytes"> & {
  /**
   * @generated from field: bytes encoded_parquet_bytes = 1;
   */
  encodedParquetBytes: Uint8Array;
};

/**
 * Describes the message chalk.arrow.v1.TableParquetBytes.
 * Use `create(TableParquetBytesSchema)` to create a new message.
 */
export const TableParquetBytesSchema: GenMessage<TableParquetBytes> = /*@__PURE__*/
  messageDesc(file_chalk_arrow_v1_arrow, 21);

/**
 * @generated from enum chalk.arrow.v1.TimeUnit
 */
export enum TimeUnit {
  /**
   * @generated from enum value: TIME_UNIT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TIME_UNIT_SECOND = 1;
   */
  SECOND = 1,

  /**
   * @generated from enum value: TIME_UNIT_MILLISECOND = 2;
   */
  MILLISECOND = 2,

  /**
   * @generated from enum value: TIME_UNIT_MICROSECOND = 3;
   */
  MICROSECOND = 3,

  /**
   * @generated from enum value: TIME_UNIT_NANOSECOND = 4;
   */
  NANOSECOND = 4,
}

/**
 * Describes the enum chalk.arrow.v1.TimeUnit.
 */
export const TimeUnitSchema: GenEnum<TimeUnit> = /*@__PURE__*/
  enumDesc(file_chalk_arrow_v1_arrow, 0);

/**
 * @generated from enum chalk.arrow.v1.FeatherCompression
 */
export enum FeatherCompression {
  /**
   * @generated from enum value: FEATHER_COMPRESSION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: FEATHER_COMPRESSION_UNCOMPRESSED = 1;
   */
  UNCOMPRESSED = 1,

  /**
   * @generated from enum value: FEATHER_COMPRESSION_LZ4 = 2;
   */
  LZ4 = 2,

  /**
   * @generated from enum value: FEATHER_COMPRESSION_ZSTD = 3;
   */
  ZSTD = 3,
}

/**
 * Describes the enum chalk.arrow.v1.FeatherCompression.
 */
export const FeatherCompressionSchema: GenEnum<FeatherCompression> = /*@__PURE__*/
  enumDesc(file_chalk_arrow_v1_arrow, 1);

